import classnames from 'classnames'
import React from 'react'

import { getQuarterAndYear } from '../../utils'

interface XAxisProps {
  yearKeys: string[]
}

const COMMON_CLASS = 'flex justify-between font-sans text-4xs text-disabled'

export function QuarterAreaXAxis({ yearKeys }: XAxisProps) {
  const { yearSegments, years } = React.useMemo(() => {
    const yearSegments = yearKeys.reduce(
      (acc, period) => {
        const { quarter, year } = getQuarterAndYear(period)
        return {
          ...acc,
          [year]: {
            hasLeftBoundary: !!acc[year]?.hasLeftBoundary || quarter.toLowerCase() === 'q1',
            hasRightBoundary: !!acc[year]?.hasRightBoundary || quarter.toLowerCase() === 'q4',
            quarters: (acc[year]?.quarters ?? 0) + 1,
          },
        }
      },
      {} as Record<string, { hasLeftBoundary: boolean; hasRightBoundary: boolean; quarters: number }>
    )
    const years = yearKeys
      .map((period) => getQuarterAndYear(period).year)
      .filter((year, index, arr) => arr.indexOf(year) === index)
    return { yearSegments, years }
  }, [yearKeys])

  return (
    <div className="space-y-1">
      <div className={classnames(COMMON_CLASS, 'px-2')}>
        {yearKeys.map((value) => (
          <span key={value} className="text-center">
            {getQuarterAndYear(value).quarter}
          </span>
        ))}
      </div>
      <div className={COMMON_CLASS}>
        {years.map((year, index) => {
          const yearSegment = yearSegments[year]
          const nextYearSegment = yearSegments[years[index + 1]]

          return (
            <span
              key={year}
              className={classnames('border-b border-secondary text-center', {
                'border-l': yearSegment.hasLeftBoundary,
                'border-r': yearSegment.hasRightBoundary && !nextYearSegment?.hasLeftBoundary,
              })}
              style={{ flex: yearSegment.quarters }}
            >
              {year}
            </span>
          )
        })}
      </div>
    </div>
  )
}
